import React from "react";
import { Navigate } from "react-router-dom";
import { isDeliveryPartner, parseStoredUser } from "@/utils/userRoles";

const PublicRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  const user = parseStoredUser();
  if (token) {
    if (isDeliveryPartner(user)) {
      return <Navigate to="/delivery-partner/new-deliveries" replace />;
    }
    return <Navigate to="/dashboard/home" replace />;
  }
  return children;
};

export default PublicRoute;
